import { defineStore } from "pinia";
import type { ITrainingPlayerStore } from "~/utils/interfaces/training-player-interfaces";

export const useTrainingPlayerStore = defineStore("TrainingPlayerStore", {
  state: (): ITrainingPlayerStore => {
    return {
      bookingId: null,
      trainingId: null,
      trainingDetails: null,
      showModal: false,
      showExit: false,
      showEnd: false,
      showSummary: false,
      showReduceSummary: false,
    };
  },
  getters: {
    getTrainingDetails() {
      /** getTrainingDetails(this.trainingId)
       *  trainingDetails = this.trainingDetails
       */
    },
  },
  actions: {},
});
